if (
  navigator.userAgent.includes("Safari") &&
  !navigator.userAgent.includes("Chrome")
) {
  document.body.classList.add("safari");
}

var filterTsEn = {
  product_results: "Product results",
  update_filter: "Update Filter",
  clear_all_filters: "Clear all filters",
  clear_filter: "Clear Filter",
  choose_type: "Choose or type in:",
  t_product_no: "Product No.",
  t_width: "Width",
  t_height: "Height",
  t_image: "Image",
  t_volume: "Volume",
  t_curve: "Curve",
  t_projection: "Projection (in mm)",
  t_lvc: "LVC",
  t_detalis: "Detalis",
  show_more: "Show More",
  title_with:
    "A = Width (Base Diameter) - Measurement across the widest part of the implant.",
  title_height:
    "B = Height - Distance from the uppermost edge of the implant to the lowermost edge.",
  title_projection:
    "C = Distance from the chest wall to the farthest point on the front of the implant.",
  title_curve:
    "D = Distance from highest point of projection to lower implant edge.",
  title_lvc:
    "LVC = Low Ventral Curvature - The LVC value is the vertical distance on the ventral implant surface. The LVC is measured from the outermost edge of the implant base to the mid-height of the implant.",
};

var filterTsDe = {
  product_results: "Produktauswahl",
  update_filter: "Aktualisieren",
  clear_all_filters: "Alle Filter zurücksetzen",
  clear_filter: "Filter löschen",
  choose_type: "Bereich wählen:",
  t_product_no: "Produktbezeichnung",
  t_width: "Breite",
  t_height: "Höhe",
  t_image: "Bild",
  t_volume: "Volumen",
  t_curve: "Kurve",
  t_projection: "Projektion (in mm)",
  t_lvc: "LVC",
  t_detalis: "Details",
  show_more: "Mehr anzeigen",
  title_width:
    "A = Implantbreite (Basisdurchmesser) - Die Messung des breitesten Stelle des Implantats.",
  title_height:
    "B = Implantathöhe - Der Abstand vom obersten Kante bis zum untersten Rand.",
  title_projection:
    "C = Projektion - Abstand von der Brustwand bis zum am weitesten entfernten Punkt auf der Vorderseite des Implantats.",
  title_curve:
    "D = Kurve - Abstand vom höchsten Punkt der Projektion zur unteren Implantatkante.",
  title_lvc:
    "LVC = Untere ventrale Krümmung - Der LVC-Wert ist die vertikale Strecke auf der ventralen Implantatoberfläche. Gemessen wird die LVC vom äußersten Rand der Implantatbasis bis zur mittleren Höhe des Implantates.",
};

var filterTsIt = {
  product_results: "Risultati del prodotto",
  update_filter: "Aggiorna filtro",
  clear_all_filters: "Ripristina tutti i filtri",
  clear_filter: "Elimina filtro",
  choose_type: "Seleziona zona:",
  t_product_no: "Nome del prodotto",
  t_width: "Larghezza",
  t_height: "Altezza",
  t_image: "Immagine",
  t_volume: "Volume",
  t_curve: "Curva",
  t_projection: "Proiezione (in mm)",
  t_lvc: "LVC",
  t_detalis: "Informazioni",
  show_more: "Mostra di più",
  title_width:
    "A = Larghezza (diametro della base) - Misura della larghezza massima della protesi.",
  title_height:
    "B = Altezza - Distanza tra la sommità superiore e quella inferiore della protesi.",
  title_projection:
    "C = Distanza dalla aparete toracica al punto della protesi ad essa più lontana.",
  title_curve:
    "D = Distanza tra il punto di massima proiezione e il bordo inferiore della protesi.",
  title_lvc:
    "LVC = Low Ventral Curvature - Il valore LVC è la distanza verticaleproiettata  sulla superficie ventrale dell'impianto. Misura la curva rappresentata dalla distanza tra il bordo inferiore della protesi e la metà dell'altezza dell'impianto.",
};

var filterTsFr = {
  product_results: "Résultats du produit",
  update_filter: "Mettre à jour le filtre",
  clear_all_filters: "Réinitialiser tous les filtres",
  clear_filter: "Supprimer le filtre",
  choose_type: "Sélectionnez une zone:",
  t_product_no: "Nom du produit",
  t_width: "Largeur",
  t_height: "Hauteur",
  t_image: "Image",
  t_volume: "Volume",
  t_curve: "Courbe",
  t_projection: "Projection (en mm)",
  t_lvc: "LVC",
  t_detalis: "Détails",
  show_more: "Afficher plus",
  title_width:
    "A = Largeur de l'implant (diamètre de base) - La mesure de la partie la plus large de l'implant.",
  title_height:
    "B = Hauteur de l'implant - La distance du bord supérieur au bord inférieur.",
  title_projection:
    "C = Projection - Distance de la paroi thoracique jusqu'au point le plus éloigné à l'avant de l'implant.",
  title_curve:
    "D = Distance entre le point de projection maximale et le bord inférieur de la prothèse.",
  title_lvc:
    "LVC = Courbure Ventral Basse - La valeur LVC est la distance verticale projetée sur la surface ventrale de l'implant. Elle mesure la courbe représentée par la distance entre le bord inférieur de la prothèse et la moitié de la hauteur de l'implant.",
};

var filterTranslations = filterTsEn;
if (Shopify.locale == "de") {
  filterTranslations = filterTsDe;
} else if (Shopify.locale == "it") {
  filterTranslations = filterTsIt;
} else if (Shopify.locale == "fr") {
  filterTranslations = filterTsFr;
}

(function () {
  if (typeof aico.jq !== "undefined") {
    var filterTableLoad = false;
    if (
      aico.collecton_handle == "polytech" ||
      aico.collecton_handle == "gluteal" ||
      aico.collecton_handle == "sleeves" ||
      aico.collecton_handle == "breast-expander" ||
      aico.collecton_handle == "pectoral" ||
      aico.collecton_handle == "b-lite" ||
      aico.collecton_handle === "polytech-zubehor" ||
      aico.collecton_handle == "sizer" ||
      aico.collecton_handle == "tissue-expander" ||
      aico.collecton_handle == "sublimeline" ||
      aico.collecton_handle == "testicular" ||
      aico.collecton_handle == "calf" ||
      aico.collecton_handle == "lipografter®"
    ) {
      filterTableLoad = true;
    }
  } else {
    setTimeout(arguments.callee, 100);
  }
})(); //end

function radioButtonChecked(request_data) {
  Object.keys(request_data).forEach(function (key) {
    if (key.startsWith("aico_t_")) {
      let values = request_data[key];
      console.log("values", values);
      values.forEach(function (value) {
        let selector = `input[type=radio][name="${key}"][value="${value}"]`;
        aico.jq(selector).each(function () {
          aico.jq(this).prop("checked", true);
          aico.jq(this).attr("checked", "checked");
        });
      });
    }
  });
}

function polytechCollectionsData() {
  request_data["polytech"] = true;
  radioButtonChecked(request_data);
  delete request_data.page;
  let rangeMinMax = null;
  aico.jq.ajax({
    url: aico.aico_url + "api/filter-data",
    method: "POST",
    data: request_data,
    success: function (response) {
      aico.jq(".productnotfoundMsg").remove();
      removeParamsFromUrl();
      appendAicoParamsToUrl();
      aico.jq(".collection ul#product-grid").remove();
      aico.jq(".product__grid-item").remove();
      aico.jq("#ProductGridContainer").html("");
      aico.jq("#ProductGridContainer").removeClass("aico_polytech");
      aico.jq("#ProductGridContainer").addClass("aico_polytech");
      productGridHtml(response);
      rangeSliderHtml(response, rangeMinMax);
      aico.jq(".aico-tags").remove();
      tagsList(response);
      selectedList(request_data, response);
      selectedTagChecked(request_data);
      aico.jq(".af-filter-message").remove();
      onloadCheckValue(request_data);
      commonFunctionLoad(response);
      if (
        response.product_count > 12 &&
        request_data.limit < response.product_count
      ) {
        let currentPage = parseInt(request_data.limit / 12) || 1;
        aico.jq(".show-more-btn").remove();
        aico
          .jq(".product-grid-table")
          .append(
            `<div class="show-more-btn"><button id="showMoreBtn" aico-page="${currentPage}">${filterTranslations.show_more}</button></div>`
          );
      }
      commonPolytect(request_data);
      radioButtonChecked(request_data);
    },
  });
}
showMoreProducts();

function showMoreProducts() {
  aico.jq(document).on("click", "#showMoreBtn", function () {
    let rangeMinMax = null;
    let pageLimit = 12;
    let currentPage = parseInt(aico.jq(this).attr("aico-page")) || 1;
    let newPage = currentPage + 1;
    let newPageLimit = pageLimit * newPage;
    aico.jq(this).attr("aico-page", newPage);
    request_data["limit"] = newPageLimit;
    delete request_data.page;
    aico.jq.ajax({
      url: aico.aico_url + "api/filter-data",
      method: "POST",
      data: request_data,
      success: function (response) {
        aico.jq(".productnotfoundMsg").remove();
        removeParamsFromUrl();
        appendAicoParamsToUrl();
        aico.jq(".collection ul#product-grid").remove();
        aico.jq(".product__grid-item").remove();
        aico.jq("#ProductGridContainer").html("");
        productGridHtml(response);
        aico.jq(".aico-tags").remove();
        tagsList(response);
        rangeSliderHtml(response, rangeMinMax);
        selectedList(request_data, response);
        selectedTagChecked(request_data);
        aico.jq(".af-filter-message").remove();
        onloadCheckValue(request_data);
        commonFunctionLoad(response);
        if (
          response.product_count > 12 &&
          request_data.limit < response.product_count
        ) {
          let currentPage = parseInt(request_data.limit / 12) || 1;
          aico.jq(".show-more-btn").remove();
          aico
            .jq(".product-grid-table")
            .append(
              `<div class="show-more-btn"><button id="showMoreBtn" aico-page="${newPage}">${filterTranslations.show_more}</button></div>`
            );
        }
        commonPolytect(request_data);
      },
    });
  });
}
function commonPolytect(request_data) {
  if (aico.jq(".af-widget").length === 0) {
    aico.jq(".aico_filter_update").hide();
    aico.jq(".aico-filter-refine-by").hide();
  } else {
    aico.jq(".aico_filter_update").show();
    aico.jq(".aico-filter-refine-by").show();
  }
  aico.jq(".aico-tags").each(function () {
    let ul = aico.jq(this).find("ul.af-widgetCheck");
    let li = ul.find("li");
    if (li.length === 1 && aico.jq(li).find(".af-label").text().trim() === "") {
      aico.jq(this).hide();
    }
  });
}
function productGridHtml(response) {
  aico.jq("#ProductGridContainer").append(
    `<div class="aico-product-grid" id="aicoProductGrid">
    <div class="aico-product-header">
        <h6>${filterTranslations.product_results}</h6>
    </div>
    <div class="product-grid-table">
        <div class="aico-filters-polytech">
            <div class="aico_filter_update">
                <div class="aico_submit">
                    <span class="btn">${filterTranslations.update_filter}</span>
                </div>
            </div>
        </div>
        <div class="af-products-table">
            <table id="productTable">
                <thead>
                    <tr>
                        <th>${filterTranslations.t_image}</th>
                        <th>${filterTranslations.t_product_no}</th>
                        <th>${filterTranslations.t_width}<i></i><span class="af_th_title">${filterTranslations.title_width}</span></th>
                        <th>${filterTranslations.t_height}<i></i><span class="af_th_title">${filterTranslations.title_height}</span></th>
                        <th>${filterTranslations.t_projection}<i></i><span class="af_th_title">${filterTranslations.title_projection}</span></th>
                        <th>${filterTranslations.t_curve}<i></i><span class="af_th_title">${filterTranslations.title_curve}</span></th>
                        <th>${filterTranslations.t_lvc}<i></i><span class="af_th_title">${filterTranslations.title_lvc}</span></th>
                        <th>${filterTranslations.t_volume}<i></i><span class="af_th_title">${filterTranslations.t_volume}</span></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                </tbody>
            </table>
        </div>
    </div>
</div>`
  );
  populateTable(response.products);
}

function createTableRow(product) {
  let productMetafield = product.metafields;
  let productTags = product.tags;
  if (productTags) {
    productTags = productTags.split(", ");
  }

  // Extract values from the tags
  let width = "NA",
    height = "NA",
    projection = "NA",
    curve = "NA",
    lvc = "NA",
    volume = "NA",
    productNo = "NA";
  if (productTags.length > 0 && productTags) {
    productTags.forEach((tag) => {
      if (tag.startsWith("cf_Dim A Breite_")) {
        width = tag.split("_")[2] || "NA";
      } else if (tag.startsWith("cf_Dim B Länge_")) {
        height = tag.split("_")[2] || "NA";
      } else if (tag.startsWith("cf_Dim C Projektion_")) {
        projection = tag.split("_")[2] || "NA";
      } else if (tag.startsWith("cf_Dim D Arc_")) {
        curve = tag.split("_")[2] || "NA";
      } else if (tag.startsWith("cf_Dim E LVC_")) {
        lvc = tag.split("_")[2] || "NA";
      } else if (tag.startsWith("cf_Volumen_")) {
        volume = tag.split("_")[2] || "NA";
      } else if (tag.startsWith("cf_Artikelnummer ALT_")) {
        productNo = tag.split("_")[2] || "NA";
      }
    });
  }

  return `<tr>
              <td><img src="${product.images.src}" alt="Product Image" width="50" height="50"></td>
              <td>${productNo}</td>
              <td>${width}</td>
              <td>${height}</td>
              <td>${projection}</td>
              <td>${curve}</td>
              <td>${lvc}</td>
              <td>${volume}</td>
              <td><a href="${Shopify.routes.root}products/${product.handle}">${filterTranslations.t_detalis}</a></td>
          </tr>`;
}

function populateTable(products) {
  const tableBody = document.querySelector("#productTable tbody");
  if (typeof products != "undefined") {
    products.forEach((product) => {
      tableBody.innerHTML += createTableRow(product);
    });
  } else {
    aico.jq(".productnotfoundMsg").remove();
    tableBody.innerHTML += `<div style="display:flex;"><p class="productnotfoundMsg">Sorry, we couldn’t find any products based on your filter criteria.</p><span class="clear-all-filter" style="margin:34px 30px;"
    >${filterTranslations.clear_all_filters}</span></div>`;
  }
}

aico.jq(document).on("click", ".aico_submit", function (event) {
  event.preventDefault();
  polytechCollectionsData();
});

aico.jq(document).on("click", ".aico_reset_button", function () {
  const parent = aico.jq(this).closest(".aico-range-slider");
  const parent1 = aico.jq(this).closest(".aico-tags");
  parent.find(".aico-specific-clear").trigger("click");
  parent1.find(".aico-specific-clear").trigger("click");
});
